import { Component, Input, OnInit } from '@angular/core';
import { NoteSection } from 'src/app/model/section/note-section';

@Component({
  selector: 'app-support-page-outage-banner-section',
  templateUrl: './support-page-outage-banner-section.component.html',
  styleUrls: ['./support-page-outage-banner-section.component.scss']
})
export class SupportPageOutageBannerSectionComponent implements OnInit {
  constructor() {}
  @Input() outageBanners: NoteSection[] = [];
  ngOnInit(): void {}
}
